module.exports = __webpack_public_path__ + "static/media/icons_Bilan Mucoviscidose.a01ccc55.svg";